function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.25 3.17H4.72L.5 9.39 15 27.26 29.5 9.39zM7.52 10.89l5.22 11.81L2.57 10.14zM8.77 9.8l2.34-5.5h7.76l2.34 5.5zm12.42 1.13l-6.2 14-6.2-14zm1.27 0l5-.75L17.24 22.7zm5.34-2l-5.41.82-2.29-5.43h4.56zM5.31 4.3h4.57L7.56 9.73l-5.4-.82z"
})));